import { BadgeType } from '@humi-design-library/components/Badge/types';

export const BENEFICIARY_TYPES = {
    primary: 'primary',
    contingent: 'contingent',
} as const;

export const PROVINCES_WITH_AGE_MAJORITY_18 = ['AB', 'MB', 'ON', 'PE', 'QC', 'SK'] as const;

export const MARITAL_STATUS = {
    single: 'single',
    commonLaw: 'common-law',
    married: 'married',
} as const;

export const BENEFICIARY_DESIGNATION = {
    estate: 'estate',
    beneficiary: 'beneficiary',
} as const;

export const ENROLLMENT_EXTENDED_BENEFITS = {
    single: 'Myself Only',
    couple: 'Myself and 1 dependant (includes partner)',
    family: 'Myself and 2 or more dependants (includes partner)',
    none: 'None, because my partner has coverage',
} as const;

export enum ChangeRequestStatus {
    accepted = 'accepted',
    declined = 'declined',
    pending = 'pending',
}

export const ENROLLMENT_FORM_STATUS: { [key: string]: { badge: BadgeType; label: string } } = {
    pending: {
        badge: 'warning',
        label: 'PENDING',
    },
    completed: {
        badge: 'success',
        label: 'COMPLETED',
    },
};
